import React, { useContext } from 'react';
import { OrganisationContext } from '../../context/organisationContext';

import { ReactComponent as ArrowRight } from '../../assets/images/arrow-right.svg';
import { SidebarMenuItemWrapper } from '../../styles/components/sidebar/sidebar.styled';

const MenuItem = ({ item, onClick, expanded }) => {
  const { checkMultiplePermission, hasMultiplePermission } = useContext(OrganisationContext);
  return (
    <SidebarMenuItemWrapper>
      <div className="menu-item">
        <div
          className="flex items-center menu-item-container mt-1"
          style={{
            opacity: hasMultiplePermission(item.permission) ? 1 : 0.5,
          }}>
          <div
            className={`flex items-center justify-between cursor w-full py-2 px-6 mi-item ${
              item.selected && (item.subitems.length > 0 ? 'mi-subitem-selected' : 'mi-item-selected')
            } `}
            onClick={() => checkMultiplePermission(() => onClick(item.id), item.permission)}>
            <div className="flex items-center">
              <item.icon className={`${item.setStrokeOfIcon ? 'mi-icon-stroke' : 'mi-icon'}`} />
              {expanded && <label className="regular-text ml-4 mi-name">{item.text}</label>}
            </div>
            {expanded && item.subitems.length > 0 && (
              <ArrowRight className={`mi-arrow ${item.open && 'mi-arrow-down'}`} />
            )}
          </div>
        </div>
        {item.subitems.length > 0 && (
          <div
            className={`flex-column cursor menu-subitems ${
              item.open ? `menu-subitems-show ${item.selected && 'menu-subitems-selected-open'}` : 'menu-subitems-hide'
            }`}
            style={{ height: item.open ? `${50 * item.subitems.length}px` : 0 }}>
            {item.subitems.map((subitem, i) => (
              <div
                key={i}
                className={`flex subitem-container cursor ${subitem.selected && 'subitem-selected'}`}
                onClick={() => checkMultiplePermission(() => onClick(item.id, subitem.id), subitem.permission)}
                style={{
                  opacity: hasMultiplePermission(subitem.permission) ? 1 : 0.5,
                }}>
                <div
                  key={subitem.id}
                  className={`flex items-center w-full subitem relative ${expanded ? 'pl-10' : 'pl-7'}`}>
                  {subitem.selected ? (
                    <subitem.iconSelected className={`${subitem.setStrokeOfIcon ? 'mi-icon-stroke' : 'mi-icon'}`} />
                  ) : (
                    <subitem.icon className={`${subitem.setStrokeOfIcon ? 'mi-icon-stroke' : 'mi-icon'}`} />
                  )}
                  {expanded && <label className="regular-text px-5 si-name">{subitem.text}</label>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </SidebarMenuItemWrapper>
  );
};

export default MenuItem;
